<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'controls.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

        <hr />

        <button
            class="btn btn-default mr-2 mb-2"
            (click)="download(ExportType.ControlAdvancedTestingHistory)"
        >
            {{ 'controls.changesInAdvancedButton' | t }}
        </button>
        @if (permService.permissions.IsDeveloperAdmin) {
            <hr />

            <mat-checkbox color="primary" name="includeMois" [(ngModel)]="includearchivedlinks"
                >{{ 'includeArchivedLinksCheckbox' | t }}</mat-checkbox
            >
            <hr />
            
            <button
                class="btn btn-default mr-2 mb-2"
                (click)="downloadControls(ExportType.ControlsForImport)"
                >
                {{ 'controls.exportForControlImportButton' | t }}
            </button>
        }
    </div>
</div>
